import img from '../../../../../assets/images/textEditorToolBarIcons/Underline.svg';

export const UnderLineButton = img;
